/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/

export enum AccountsChildrenTypeEnumType {
  Custodied = "Custodied",
  Joint = "Joint",
  Member = "Member",
  Signer = "Signer",
}
